export default {
  form: {
    amount: {
      label: 'Cena',
    },
    has_sales_based_discount: {
      label: 'Rabaty na podstawie miesięcznej sprzedaży',
    },
  },
  labels: {
    month: 'miesiąc',
    varies_by_tier: 'zależnie od progu',
    max_price: '* Cena maksymalna wynosi {{amount}}',
    sales_based_discount:
      'do +{{threshold}} minimalnej sprzedaży miesięcznie. Powyżej cena regularna {{amount}} netto/miesiąc',
  },
  tax: {
    inclusive: '{{taxName}}: {{tax}} (wliczony)',
    exclusive: 'miesięcznie plus {{taxName}}: {{tax}}',
  },
  buttons: {
    select: 'Wybierz',
    save: 'Zapisz',
    use_default_price: 'Użyj domyślnej ceny',
  },
};
